const messages = {
  es: {
    'nav.catalog': 'Catálogo',
    'nav.favorites': 'Favoritos',
    'nav.dashboards': 'Dashboards',
    'nav.admin': 'Administración',
    'error.not_found': 'Página no encontrada',
    'error.not_found_desc': 'La página que buscas no existe o no tienes permisos para verla.',
    'error.generic': 'Se ha producido un error',
    'error.generic_desc': 'Por favor, recarga la página o contacta con soporte.',
    'error.go_home': 'Ir al catálogo',
    'user.logout': 'Cerrar sesión',
    'user.profile': 'Mi perfil',
    loading: 'Cargando...',
    'catalog.search_placeholder': 'Buscar informes…',
    'catalog.category': 'Categoría',
    'catalog.kind': 'Tipo',
    'catalog.kind.report': 'Informe',
    'catalog.kind.dashboard': 'Dashboard',
    'catalog.kind.all': 'Todos',
    'catalog.favorites_only': 'Sólo favoritos',
    'catalog.clear_filters': 'Limpiar filtros',
    'catalog.no_results': 'Ningún informe encontrado',
    'catalog.no_results_desc':
      'Prueba a cambiar los filtros o elimínalos para ver todos los informes.',
    'catalog.last_execution': 'Última ejecución',
    'catalog.loading': 'Cargando el catálogo…',
    'catalog.error': 'Error al cargar el catálogo',
    'catalog.retry': 'Reintentar',
    'catalog.page_of': 'Página {page} de {total}',
    'catalog.total_items': '{count} informes',
    'catalog.view_grid': 'Vista cuadrícula',
    'catalog.view_list': 'Vista lista',
    'catalog.favorite_add': 'Añadir a favoritos',
    'catalog.favorite_remove': 'Quitar de favoritos',
    'catalog.ago_just_now': 'Ahora mismo',
    'catalog.ago_minutes': 'Hace {n} min',
    'catalog.ago_hours': 'Hace {n} h',
    'catalog.ago_days': 'Hace {n} d',
    'catalog.never': 'Nunca ejecutado',
    'catalog.rows': '{n} filas',
    'catalog.duration_ms': '{n} ms',
    'catalog.version_update_available': 'Versión actualizada disponible',
    'catalog.capability_view': 'Ver',
    'catalog.capability_execute': 'Ejecutar',
    'catalog.capability_manage': 'Administrar',
    'report.loading': 'Cargando informe…',
    'report.error': 'Error al cargar el informe',
    'report.not_found': 'Informe no encontrado',
    'report.execute': 'Ejecutar',
    'report.execute_fresh': 'Ejecutar (sin caché)',
    'report.executing': 'Ejecutando…',
    'report.reset_params': 'Restablecer valores',
    'report.export': 'Exportar',
    'report.favorite_add': 'Añadir a favoritos',
    'report.favorite_remove': 'Quitar de favoritos',
    'report.cache_hit': 'Desde caché',
    'report.duration_ms': '{n} ms',
    'report.rows_count': '{n} filas',
    'report.last_execution': 'Última ejecución: {when}',
    'report.no_results': 'Sin resultados',
    'report.no_results_desc':
      'La consulta no devolvió filas. Ajusta los parámetros y vuelve a ejecutar.',
    'report.error_param_validation': 'Revisa los parámetros del formulario.',
    'report.error_semi_join': 'Demasiados resultados pre-consulta. Refina los filtros.',
    'report.error_erp': 'Error temporal con el ERP. Reintenta en unos segundos.',
    'report.error_permission': 'No tienes permiso para ejecutar este informe.',
    'report.error_generic': 'Error al ejecutar el informe.',
    'report.error_rate_limit':
      'Has superado el límite de peticiones. Espera unos segundos y vuelve a intentarlo.',
    'report.error_timeout':
      'La consulta tardó demasiado. Intenta refinar los filtros o reduce el rango de fechas.',
    'report.error_data_scope_invalid':
      'Hay un problema con los permisos sobre los datos. Contacta con el administrador.',
    'report.error_insufficient_grant': 'No tienes permiso para ejecutar este informe.',
    'report.error_tenant_report_disabled':
      'Este informe ha sido deshabilitado por el administrador.',
    'report.applied_query': 'Consulta aplicada',
    'report.applied_query_copy': 'Copiar',
    'report.applied_query_copied': 'Copiado',
    'report.column_settings': 'Columnas',
    'report.showing_rows': 'Mostrando {shown} de {total} filas',
    'export.title': 'Exportar informe',
    'export.format': 'Formato',
    'export.format_csv': 'CSV',
    'export.format_xlsx': 'Excel (XLSX)',
    'export.format_pdf': 'PDF (próximamente)',
    'export.filename': 'Nombre de archivo',
    'export.start': 'Exportar',
    'export.cancel': 'Cancelar',
    'export.download': 'Descargar',
    'export.preparing': 'Preparando…',
    'export.progress': '{n}%',
    'export.completed': 'Exportación completada',
    'export.failed': 'Error en la exportación',
    'export.timeout': 'Exportación tomó demasiado tiempo. Reintenta o contacta soporte.',
    'chart.unsupported_kind': "Tipo de visualización '{kind}' próximamente disponible",
    'params.required': 'Campo obligatorio',
    'params.invalid_date': 'Fecha inválida',
    'params.invalid_number': 'Número inválido',
    'params.min': 'El valor mínimo es {min}',
    'params.max': 'El valor máximo es {max}',
    'params.search_placeholder': 'Buscar…',
    'params.no_options': 'Sin resultados',
    // === hito 4.5 dashboards ===
    'dashboards.page_title': 'Cuadro de mando',
    'dashboards.refresh_all': 'Actualizar todo',
    'dashboards.refresh_widget': 'Actualizar',
    'dashboards.widget_error_title': 'Error al cargar widget',
    'dashboards.not_a_dashboard': 'Este informe no es un cuadro de mando',
    'dashboards.no_widgets': 'Este cuadro no tiene widgets configurados',
    'dashboards.partial_failure': '{failed} de {total} widgets fallaron',
    'dashboards.meta_widgets': '{count} widgets',
    'dashboards.meta_succeeded': '{count} OK',
    'dashboards.meta_failed': '{count} con error',
    'dashboards.meta_duration': 'Ejecutado en {ms}ms',
    'dashboards.executed_at': 'Ejecutado',
    // === end hito 4.5 ===
    // === hito 4.7 exports ===
    'exports.page_title': 'Exportaciones',
    'exports.page_subtitle': 'Últimos 30 días',
    'exports.filter_status': 'Estado',
    'exports.filter_format': 'Formato',
    'exports.filter_all': 'Todos',
    'exports.status_queued': 'En cola',
    'exports.status_running': 'En curso',
    'exports.status_completed': 'Completado',
    'exports.status_failed': 'Fallido',
    'exports.status_cancelled': 'Cancelado',
    'exports.format_csv': 'CSV',
    'exports.format_xlsx': 'Excel',
    'exports.format_pdf': 'PDF',
    'exports.action_download': 'Descargar',
    'exports.action_cancel': 'Cancelar',
    'exports.cancel_confirm': '¿Cancelar esta exportación?',
    'exports.no_exports': 'No hay exportaciones',
    'exports.refresh': 'Actualizar',
    'exports.requested_at': 'Solicitado',
    'exports.completed_at': 'Completado',
    'exports.size': 'Tamaño',
    'exports.rows': '{count} filas',
    'exports.size_bytes': '{n} bytes',
    'exports.size_kb': '{n} KB',
    'exports.size_mb': '{n} MB',
    // === end hito 4.7 ===
    // === hito 4.8 admin ===
    'admin.nav_templates': 'Plantillas',
    'admin.nav_tenant_templates': 'Instalaciones',
    'admin.nav_roles': 'Roles',
    'admin.nav_grants': 'Permisos',
    'admin.nav_audit_log': 'Auditoría',
    'admin.templates.title': 'Plantillas globales',
    'admin.templates.new': 'Nueva plantilla',
    'admin.templates.validate': 'Validar',
    'admin.templates.publish': 'Publicar',
    'admin.templates.deprecate': 'Deprecar',
    'admin.templates.status_active': 'Activa',
    'admin.templates.status_deprecated': 'Deprecada',
    'admin.templates.filter_code': 'Filtrar por código…',
    'admin.templates.filter_kind': 'Tipo',
    'admin.templates.filter_status': 'Estado',
    'admin.templates.no_results': 'No hay plantillas',
    'admin.templates.definition': 'Definición',
    'admin.templates.changelog': 'Changelog',
    'admin.tenant_templates.title': 'Instalaciones del tenant',
    'admin.tenant_templates.install': 'Instalar',
    'admin.tenant_templates.migrate': 'Migrar versión',
    'admin.tenant_templates.uninstall': 'Desinstalar',
    'admin.tenant_templates.enabled': 'Habilitado',
    'admin.tenant_templates.disabled': 'Deshabilitado',
    'admin.roles.title': 'Roles',
    'admin.roles.new': 'Nuevo rol',
    'admin.roles.code': 'Código',
    'admin.roles.name': 'Nombre',
    'admin.roles.description': 'Descripción',
    'admin.roles.is_default': 'Rol por defecto',
    'admin.roles.tab_info': 'Información',
    'admin.roles.tab_members': 'Miembros',
    'admin.roles.tab_rules': 'Reglas',
    'admin.roles.delete_confirm': '¿Eliminar este rol? No se puede deshacer.',
    'admin.roles.members_count': '{n} miembros',
    'admin.roles.grants_count': '{n} permisos',
    'admin.roles.rules_count': '{n} reglas',
    'admin.role_members.add': 'Añadir miembro',
    'admin.role_members.batch': 'Lote',
    'admin.role_members.remove': 'Eliminar',
    'admin.role_members.source_manual': 'Manual',
    'admin.role_members.source_rule': 'Regla',
    'admin.role_members.rule_sourced_hint':
      'Este miembro fue añadido por una regla. Desactiva la regla para eliminarlo.',
    'admin.role_rules.add': 'Añadir regla',
    'admin.role_rules.test': 'Probar',
    'admin.role_rules.apply': 'Aplicar',
    'admin.role_rules.enable': 'Activar',
    'admin.role_rules.disable': 'Desactivar',
    'admin.role_rules.field': 'Campo',
    'admin.role_rules.op': 'Operador',
    'admin.role_rules.value': 'Valor',
    'admin.role_rules.matched': '{n} coincidencias',
    'admin.grants.title': 'Permisos',
    'admin.grants.new': 'Nuevo permiso',
    'admin.grants.matrix': 'Matriz',
    'admin.grants.subject_type': 'Tipo de sujeto',
    'admin.grants.subject_id': 'ID de sujeto',
    'admin.grants.level_view': 'Ver',
    'admin.grants.level_execute': 'Ejecutar',
    'admin.grants.level_full': 'Completo',
    'admin.grants.data_scope': 'Filtros de datos',
    'admin.grants.delete_confirm': '¿Eliminar este permiso?',
    'admin.grants.matrix_save': 'Guardar matriz',
    'admin.grants.matrix_applied': '{n} cambio(s) aplicado(s)',
    'admin.audit_log.title': 'Auditoría',
    'admin.audit_log.filter_from': 'Desde',
    'admin.audit_log.filter_to': 'Hasta',
    'admin.audit_log.filter_actor': 'Actor',
    'admin.audit_log.filter_action': 'Acción',
    'admin.audit_log.filter_resource_type': 'Tipo de recurso',
    'admin.audit_log.filter_resource_id': 'ID de recurso',
    'admin.audit_log.no_results': 'Sin entradas de auditoría',
    'admin.audit_log.before': 'Antes',
    'admin.audit_log.after': 'Después',
    'admin.forbidden': 'Acceso denegado',
    'admin.forbidden_desc': 'No tienes permiso para acceder al panel de administración.',
    // === end hito 4.8 ===
    // === hito 4.6 saved views ===
    'saved_views.menu_label': 'Vistas guardadas',
    'saved_views.save_current': 'Guardar vista actual…',
    'saved_views.manage': 'Gestionar vistas…',
    'saved_views.personal': 'Personales',
    'saved_views.shared': 'Compartidas',
    'saved_views.dialog_save_title': 'Guardar vista',
    'saved_views.dialog_save_button': 'Guardar',
    'saved_views.dialog_manage_title': 'Gestionar vistas',
    'saved_views.dialog_close': 'Cerrar',
    'saved_views.field_name': 'Nombre',
    'saved_views.field_scope': 'Visibilidad',
    'saved_views.scope_personal': 'Personal',
    'saved_views.scope_shared': 'Compartida con todos',
    'saved_views.scope_shared_disabled_hint': 'Requiere permisos de administrador',
    'saved_views.action_rename': 'Cambiar nombre',
    'saved_views.action_delete': 'Eliminar',
    'saved_views.action_share': 'Cambiar a compartida',
    'saved_views.action_unshare': 'Cambiar a personal',
    'saved_views.delete_confirm': '¿Eliminar esta vista? No se puede deshacer.',
    'saved_views.empty': 'No tienes vistas guardadas',
    'saved_views.owner': 'Propietario',
    'saved_views.updated': 'Actualizada',
    // === end hito 4.6 ===
  },
} as const;

export type Locale = keyof typeof messages;
export type MessageKey = keyof (typeof messages)['es'];

export function t(key: MessageKey, locale: Locale = 'es'): string {
  return messages[locale][key];
}

export { messages };
